const AUTHED_KEY = 'mzz_authed'

export function isAuthedFlag() {
  try {
    return localStorage.getItem(AUTHED_KEY) === '1'
  } catch (e) {
    return false
  }
}

export function setAuthedFlag(value) {
  try {
    if (value) {
      localStorage.setItem(AUTHED_KEY, '1')
    } else {
      localStorage.removeItem(AUTHED_KEY)
    }
  } catch (e) {
    // ignore
  }
}

export function clearAuthLocal() {
  setAuthedFlag(false)
}

/**
 * 检测可读 Cookie mzz_auth（HttpOnly 的 mzz_tok 无法由 JS 读取）
 */
export function hasAuthCookie() {
  if (typeof document === 'undefined') return false
  return /(?:^|;\s*)mzz_auth=1(?:;|$)/.test(document.cookie)
}

export function isLikelyLoggedIn() {
  return isAuthedFlag() || hasAuthCookie()
}
